/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_GoogleInputs */

const en_auth_login_google = /** @type {(inputs: Auth_Login_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login with Google`)
};

const pl_auth_login_google = /** @type {(inputs: Auth_Login_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaloguj się przez Google`)
};

/**
* | output |
* | --- |
* | "Login with Google" |
*
* @param {Auth_Login_GoogleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_login_google = /** @type {((inputs?: Auth_Login_GoogleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_GoogleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_login_google(inputs)
	return en_auth_login_google(inputs)
});